import { render, staticRenderFns } from "./TableIntegrationSettings.vue?vue&type=template&id=65cd01a7&scoped=true&"
import script from "./TableIntegrationSettings.vue?vue&type=script&lang=js&"
export * from "./TableIntegrationSettings.vue?vue&type=script&lang=js&"
import style0 from "./TableIntegrationSettings.vue?vue&type=style&index=0&id=65cd01a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cd01a7",
  null
  
)

export default component.exports